import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';

interface UserDTO {
  id: string;
  nombre: string;
  email: string;
  role: string;
}

export function useResidentes() {
  return useQuery({
    queryKey: ['users', 'residentes'],
    queryFn: async () => {
      const response = await api.get<{ data: UserDTO[] }>('/users', {
        params: { role: 'residente' },
      });
      return response.data.data;
    },
  });
}
